import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { NotificationService } from 'src/app/services/notification.service';
import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';
import { Component, EventEmitter, OnInit, Output, AfterViewInit } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { FormularioService } from 'src/app/services/formulario.service';
import { HttpErrorResponse } from '@angular/common/http';
import { map, startWith, take } from 'rxjs/operators';
import { GeneralService } from 'src/app/services/general.service';
import { GeneralComponent } from 'src/app/shared/general.component';
import { CardBarCodeComponent } from 'src/app/shared/card-barcode/card-barcode.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua007-card-III',
    templateUrl: './qua007-card-III.component.html'
})

export class Qua007CardIIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public filteredOptions: Observable<DropDownListDTO[]>;
    public listTransportadora?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTransportadoraOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listAmostra?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listAmostraOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public disableBtnDt: boolean;

    @Output() mkCalc = new EventEmitter();
    @Output() mkCalcPreBasica = new EventEmitter();
    @Output() mkHarvestWeek = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService,
        protected formBuilder: FormBuilder,
        protected notificationService: NotificationService,
        protected generalService: GeneralService,
        public dialog: MatDialog
    ) {
        super('Etapa 3', false);


        if (this.isComercial || this.isBasica) {

            this.formulario = this.formBuilder.group({
                Ticket: [null, []],
                Placa_carreta: [null, [Validators.pattern('\[A-Z a-z]{3}[0-9][0-9A-Z a-z][0-9]{2}')]],
                Transportadora: [null, []],
                Dt: [null, []],
                Nfp_nota_fiscal: [null, []],
                Chegada_patio_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
                Chegada_patio_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],
                Tempo_percurso: [null, []],
                Distancia_campo: [null, []],
                Dt_pesagem_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
                Dt_pesagem_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],
            });
        }
        else {
            this.step = 'Dados do Recebimento: '

            this.formulario = this.formBuilder.group({
                // Ticket: [null, []],
                // Placa_carreta: [null, [Validators.pattern('\[A-Z a-z]{3}[0-9][0-9A-Z a-z][0-9]{2}')]],
                // Transportadora: [null, []],
                // Dt: [null, []],
                // Nfp_nota_fiscal: [null, []],
                Chegada_patio_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate), Validators.required]],
                Chegada_patio_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],
                Tempo_percurso: [null, [Validators.required]],
                Distancia_campo: [null, [Validators.required]],

                Inicio_descarga_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate), Validators.required]],
                Inicio_descarga_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],

                Termino_descarga_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate), Validators.required]],
                Termino_descarga_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],
                Tempo_Total_de_descarga: [null, [Validators.required]],
                Amostra_seca_molhada: [null, [Validators.required]],
                Umidade_recebimento: [null, [Validators.required]],
                Temperatura_recebimento: [null, [Validators.required]],
                Peso_total_rw: [null, [Validators.required]],
            });
        }
    }

    async ngOnInit(): Promise<void> {
        await this.checkBtnLeitorEnable()
        await this.getLists();

    }
    async getLists() {

        if (this.isComercial || this.isBasica) {
            await Promise.all([this.getListTransportadora()]);
        }
        else {
            await this.getListAmostra()
        }
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    alertaData() {
        const dataAtual: any = moment(new Date());


        const dataChegadaPatio = moment(this.formulario.get('Chegada_patio_data')?.value as string, 'DD/MM/YYYY');
        const dataPesagem = moment(this.formulario.get('Dt_pesagem_data')?.value as string, 'DD/MM/YYYY');


        const diffChegadaPatio = Math.abs(dataAtual.diff(dataChegadaPatio, 'days'));
        const diffPesagem = Math.abs(dataAtual.diff(dataPesagem, 'days'));



        if (diffChegadaPatio > 7 || diffPesagem > 7) {
            this.notificationService.sendNotification('', TypeMessage.DiffDias, ActionMessage.Warning);
        }
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    createFilterTransportadora(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listTransportadoraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTransportadora = this.listTransportadoraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTransportadora = this.listTransportadoraOriginal;
            }
        } else {
            this.listTransportadora = this.listTransportadoraOriginal;
        }
        // this.filteredOptions = this.formulario.get('Transportadora').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listTransportadora, value))
        //     );
    }

    async getListTransportadora(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite();
        await this.formularioService.getListDropDownList('qua007', 'transportadora', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listTransportadora = this.generalService.orderByDropDownList(response.data as DropDownListDTO[], true);
                this.listTransportadoraOriginal = this.listTransportadora;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
    async getListAmostra(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite();
        await this.formularioService.getListDropDownList('qua007', 'amostra_seca_molhada', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listAmostra = this.generalService.orderByDropDownList(response.data as DropDownListDTO[], true);
                this.listAmostraOriginal = this.listAmostra;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
    createFilterAmostra(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listAmostraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listAmostra = this.listAmostraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listAmostra = this.listAmostraOriginal;
            }
        } else {
            this.listAmostra = this.listAmostraOriginal;
        }
        // this.filteredOptions = this.formulario.get('Transportadora').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listTransportadora, value))
        //     );
    }
    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }
    async makeCalculationsPreBasica(): Promise<void> {
        this.mkCalcPreBasica.emit();
    }


    async openDialog(): Promise<void> {
        await this.checkBtnLeitorDisable();
        const dialogRef = this.dialog.open(CardBarCodeComponent, {
            width: '670px',
            height: '700px',
            data: {
                field: 'DT',
            },
        });
        dialogRef.afterClosed().subscribe(async data => {
            await this.checkBtnLeitorEnable();
            this.formulario.get('Dt').setValue(data);
        });
    }

    async checkBtnLeitorDisable(): Promise<void> {
        this.disableBtnDt = true;
    }

    async checkBtnLeitorEnable(): Promise<void> {
        this.disableBtnDt = false;
    }

    async calcHarvestWeek(): Promise<void> {
        this.mkHarvestWeek.emit();
    }
}
